import { get } from 'lodash'
import createDatasetObject from './createDatasetObject'
import { getReadWriteType } from './datasetConfigHelper'
import { getRouterDatasetConfig } from './routerDataset'
import {
  nonNullable,
  type EditorSDK,
} from '@wix/wix-data-client-common-standalone'
import type { ComponentRef } from '@wix/editor-platform-sdk-types'
import { match } from 'ts-pattern'
import type { DatasetType } from '@wix/wix-data-client-common'
import {
  DATASET,
  WIDGET_DATASET,
  ROUTER_DATASET,
} from '@wix/wix-data-client-common'

export default async function (
  editorSdkProxy: EditorSDK,
  componentRef: ComponentRef,
) {
  const controllersInfo =
    await editorSdkProxy.controllers.listConnectableControllers({
      componentRef,
    })

  const maybeControllers = await Promise.all(
    controllersInfo.map(async ({ controllerRef }) => {
      const { type, config, displayName } =
        await editorSdkProxy.controllers.getData({ controllerRef })

      try {
        const fullConfig = await match(type as DatasetType)
          .with(DATASET, WIDGET_DATASET, () => config)
          .with(ROUTER_DATASET, () =>
            getRouterDatasetConfig(editorSdkProxy, controllerRef, config),
          )
          .exhaustive()
        const collectionName = get(fullConfig, ['dataset', 'collectionName'])

        return {
          controllerRef,
          collectionName,
          type,
          config,
          displayName,
        }
      } catch {
        return null
      }
    }),
  )

  return maybeControllers
    .filter(nonNullable)
    .map(({ controllerRef, collectionName, displayName, type, config }) =>
      createDatasetObject(
        controllerRef,
        displayName,
        collectionName,
        type,
        getReadWriteType(config),
      ),
    )
}
